import type { SmartlistSegment } from "./routes.types";

export const PROJECTS_ROUTE = "/projects";
export const INSIGHTS_ROUTE = "/insights";
export const FAST_CHANNELS_ROUTE = "/fast-channels";
export const CASTINGS_ROUTE = "/castings";
export const ADMIN_USERS_ROUTE = "/admin-users";
export const PROFILE_ROUTE = "/profile";
export const ORGANIZATION_CONFIGURATION_ROUTE = "/organization/configuration";
export const CONTENTS_ROUTE = "/contents";
export const LOGIN_ROUTE = "/login";
export const SIGNUP_ROUTE = "/signup";
export const OAUTH_ROUTE = "/oauth";
export const HOSTED_CONTENTS_ROUTE = `${CONTENTS_ROUTE}/hosted`;
export const LIVE_CONTENTS_ROUTE = `${CONTENTS_ROUTE}/live`;
export const EXTERNAL_CONTENTS_ROUTE = `${CONTENTS_ROUTE}/external`;
export const FAST_CONTENTS_ROUTE = `${CONTENTS_ROUTE}/fast`;
export const ENCODINGS_ROUTE = "/encodings";
export const ENCODING_PROFILES_ROUTE = "/encoding-profiles";
export const BULKS_ROUTE = "/bulks";

export type RoutePath =
  | typeof PROJECTS_ROUTE
  | typeof INSIGHTS_ROUTE
  | typeof FAST_CHANNELS_ROUTE
  | typeof CASTINGS_ROUTE
  | typeof ADMIN_USERS_ROUTE
  | typeof PROFILE_ROUTE
  | typeof ORGANIZATION_CONFIGURATION_ROUTE
  | typeof CONTENTS_ROUTE
  | typeof LOGIN_ROUTE
  | typeof SIGNUP_ROUTE
  | typeof OAUTH_ROUTE
  | typeof HOSTED_CONTENTS_ROUTE
  | typeof LIVE_CONTENTS_ROUTE
  | typeof EXTERNAL_CONTENTS_ROUTE
  | typeof FAST_CONTENTS_ROUTE
  | typeof ENCODINGS_ROUTE
  | typeof ENCODING_PROFILES_ROUTE
  | typeof BULKS_ROUTE;

export function contentPath(
  type: string | undefined,
  uuid: string | undefined,
): string | undefined {
  if (!type || !uuid) return undefined;
  return `${CONTENTS_ROUTE}/${type}/${uuid}`;
}

export function castingPath(uuid: string): string {
  return `${CASTINGS_ROUTE}/${uuid}`;
}

export function displayPath(
  projectSlug: string | undefined,
  uuid: string | undefined,
): string | undefined {
  if (!projectSlug || !uuid) return undefined;
  return `${PROJECTS_ROUTE}/${projectSlug}/displays/${uuid}`;
}

export function userEditPath(
  projectSlug: string | undefined,
  uuid: string | undefined,
): string | undefined {
  if (!projectSlug || !uuid) return undefined;
  return `${PROJECTS_ROUTE}/${projectSlug}/users/edit/${uuid}`;
}

export function smartlistEditPath(
  projectSlug: string | undefined,
  segment: SmartlistSegment,
  uuid: string | undefined,
): string | undefined {
  if (!projectSlug || !uuid) return undefined;
  return `${PROJECTS_ROUTE}/${projectSlug}/${segment}/edit/${uuid}`;
}

export function fastChannelDistributePath(uuid: string): string {
  return `${FAST_CHANNELS_ROUTE}/${uuid}/distribute`;
}

export function eduEditPath(projectSlug: string, uuid: string): string {
  return `${PROJECTS_ROUTE}/${projectSlug}/institutions/edit/${uuid}`;
}

export function giftEditPath(projectSlug: string, uuid: string): string {
  return `${PROJECTS_ROUTE}/${projectSlug}/gift/edit/${uuid}`;
}

export function advertisingPath(projectSlug: string, uuid: string): string {
  return `${PROJECTS_ROUTE}/${projectSlug}/advertisings/edit/${uuid}`;
}

export function contentAnalyticsPath(
  projectSlug: string | undefined,
  uuid: string | undefined,
): string | undefined {
  if (!projectSlug || !uuid) return undefined;
  return `${PROJECTS_ROUTE}/${projectSlug}/analytics/content/${uuid}`;
}

export function offerEditPath(
  projectSlug: string | undefined,
  uuid: string | undefined,
): string | undefined {
  if (!projectSlug || !uuid) return undefined;
  return `${PROJECTS_ROUTE}/${projectSlug}/offers/edit/${uuid}`;
}

export function offerViewPath(projectSlug: string, uuid: string): string {
  return `${PROJECTS_ROUTE}/${projectSlug}/offer/view/${uuid}`;
}

export function freecopyEditPath(projectSlug: string, uuid: string): string {
  return `${PROJECTS_ROUTE}/${projectSlug}/freecopy/edit/${uuid}`;
}

export function freecopyCodeEditPath(
  projectSlug: string,
  uuid: string,
): string {
  return `${PROJECTS_ROUTE}/${projectSlug}/freecopy-code/edit/${uuid}`;
}

export function fastPlaylistEditPath(channelId: string, uuid: string): string {
  return `${FAST_CHANNELS_ROUTE}/${channelId}/fast-playlists/${uuid}`;
}

export function fastPlaylistNewPath(channelId: string): string {
  return fastPlaylistEditPath(channelId, "new-playlist");
}

/** `uuid` vaut `new` pour la création d'un gabarit. */
export function fastTemplatePath(channelId: string, uuid: string): string {
  return `${FAST_CHANNELS_ROUTE}/${channelId}/templating/${uuid}`;
}

export function adBreakPath(channelId: string, uuid: string): string {
  return `${FAST_CHANNELS_ROUTE}/${channelId}/ad-breaks/${uuid}`;
}

export function adBreakNewPath(channelId: string): string {
  return adBreakPath(channelId, "new-adbreak");
}

/** `uuid` vaut `new` pour la création d'un créneau horaire. */
export function timeslotPath(channelId: string, uuid: string): string {
  return `${FAST_CHANNELS_ROUTE}/${channelId}/timeslots/${uuid}`;
}

export function commentViewPath(projectSlug: string, uuid: string): string {
  return `${PROJECTS_ROUTE}/${projectSlug}/comments/view/${uuid}`;
}
